import { Routes, Route, BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AuthHOC from "./components/HOC/AuthHOC";
import UserGate from "./components/HOC/UserGate";
import { ROUTES, combinedRoutes } from "./config/nav";
import Redirector from "./components/HOC/Redirector";
import LoginPage from "./pages/LoginPage/LoginPage";
import LoginRedirector from "./components/HOC/LoginRedirector";
import HomePage from "./pages/HomePage";
import ForgotPasswordSendEmailPage from "./pages/ForgotPasswordSendUsernamePage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ForgotPasswordTokenRedirectorPage from "./pages/ForgotPasswordTokenRedirectorPage";
import ExpiredLinkResendEmailPasswordPage from "./pages/ExpiredLinkResendUsernamePasswordPage";
import QrCodeScannerPage from "./pages/QrCodeScannerPage";
import DetailSafetyChecklistVehiclePage from "./pages/SafetyCheckListPages/DetailSafetyChecklistVehiclePage";
import DetailResultSafetyChecklistPage from "./pages/SafetyCheckListPages/DetailResultSafetyChecklistPage";
import SafetyChecklistPage from "./pages/SafetyCheckListPages/SafetyChecklistPage";
import DetectConnectionComponent from "./components/DetectConnectionComponent";
import SafetyCheckVehicleListPage from "./pages/SafetyCheckListPages/SafetyCheckVehicleListPage";
import SafetyChecklistInactivePage from "./pages/SafetyCheckListPages/SafetyChecklistInactivePage";

function App() {
  return (
    <DetectConnectionComponent>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AuthHOC />}>
            <Route path={ROUTES.home} element={<Redirector />} />
            <Route
              path={combinedRoutes.admin}
              element={<UserGate allowedUsers={["FSO"]} />}
            >
              <Route index element={<HomePage />} />
              <Route
                path={`${combinedRoutes.scan_qr}`}
                element={<QrCodeScannerPage />}
              />
              <Route
                path={`${combinedRoutes.vehicle_list}`}
                element={<SafetyCheckVehicleListPage />}
              />
              <Route
                path={`${combinedRoutes.vehicle_detail}/:id`}
                element={<DetailSafetyChecklistVehiclePage />}
              />
              <Route
                path={`${combinedRoutes.vehicle_checklist}/:id`}
                element={<SafetyChecklistPage />}
              />
              <Route
                path={`${combinedRoutes.safety_check_inactive}/:id`}
                element={<SafetyChecklistInactivePage />}
              />
              <Route
                path={`${combinedRoutes.result}/:id`}
                element={<DetailResultSafetyChecklistPage />}
              />
            </Route>
            <Route
              path={combinedRoutes.guest}
              element={<UserGate allowedUsers={["GUEST"]} />}
            >
              <Route index element={<HomePage />} />
              <Route
                path={`${combinedRoutes.guest_scan_qr}`}
                element={<QrCodeScannerPage />}
              />
              <Route
                path={`${combinedRoutes.guest_vehicle_detail}/:id`}
                element={<DetailSafetyChecklistVehiclePage />}
              />
            </Route>
          </Route>
          <Route
            path={ROUTES.loginpage}
            element={
              <LoginRedirector>
                <LoginPage />
              </LoginRedirector>
            }
          />
          <Route
            path={`${ROUTES.forgotPassword}/sendemail`}
            element={<ForgotPasswordSendEmailPage />}
          />
          <Route
            path={`${ROUTES.forgotPassword}/resendemailexpired`}
            element={<ExpiredLinkResendEmailPasswordPage />}
          />
          <Route
            path={`${ROUTES.forgotPassword}/resetpassword`}
            element={<ForgotPasswordPage />}
          />
          <Route
            path={`${ROUTES.forgotPassword}/token/:token`}
            element={<ForgotPasswordTokenRedirectorPage />}
          />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </DetectConnectionComponent>
  );
}

export default App;
